module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_45.427eca80.png";